import React, { useState } from "react";
import { FaFacebook, FaGoogle } from "react-icons/fa";
import { Caption, Container, PrimaryButton, Title } from "../../router";
import { commonClassNameOfInput } from "../../components/common/Design";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setUserSession } from './2fa/AuthService'
import axios from 'axios'
export const Login = () => {

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const navigate = useNavigate(); 
  const onChange = async (e) => {
    setUsername(e.target.value)
}
  const handleSubmit = async (e) => {
    e.preventDefault();
   
    
    //alert(process.env.REACT_APP_API_URL)
    if (username =='' || password =='') {
      toast.error("Cannot log in to the system. The username or password is empty. Please check and try again", { theme: 'colored' })
   }
   else{
    toast.warning("Please wait, processing your credentials.", {theme: 'colored'});
    const requestBody = {
      username: username,
      password: password
  }
  
  let responseData = await axios.post(`${process.env.REACT_APP_API_URL}sign-in`, requestBody).then(response => {
      console.log(response)
      localStorage.setItem("token", response.data.token)
      localStorage.setItem("email", response.data.email)
      //localStorage.setItem("_id", "253876F1A")
      toast.success("Login Successfully", { theme: 'colored' })
      setUserSession(username, response.data.token)
      window.location.href = `${process.env.REACT_APP_BASE_URL}2fa`;
  
  
  }).catch(error => {
      console.log(error)
       if (error.response.status === 400 || error.response.status === 403) {
          toast.error(error.response.data.status, { theme: 'colored' })
      } else {
          toast.error("sorry... the backend server is down!! please try again later", { theme: 'colored' })
      }
  })
}  
 

}
  return (
    <>
      <section className="relative pt-16 regsiter">
        <div className="absolute rounded-full bg-green w-96 h-96 opacity-20 blur-3xl top-2/3"></div>
        <form className="w-1/3 p-8 m-auto my-16 bg-white shadow-s3 rounded-xl">
          <div className="text-center">
            <Title level={5}>Welcome to the Cricket Alert System</Title>
          </div> 

          <div className="py-5 mt-8">
            <Caption className="mb-2">Enter Your Email or Phone Number</Caption>
            <input type="email" name="email" className={commonClassNameOfInput} placeholder="Enter Your Email" required  onChange={onChange}
                                value={username}/>
          </div>
          <div>
            <Caption className="mb-2">Password *</Caption>
            <input type="password" name="password" className={commonClassNameOfInput} placeholder="Enter Your Password" required onChange={(e) => setPassword(e.target.value)} value={password} />
          </div>
          <div className="flex items-center gap-2 py-4">
            <input type="checkbox" />
            <Caption>I agree to the Terms & Policy</Caption>
          </div>
          <button type="submit" onClick={handleSubmit} className='w-full px-16 py-3 my-5 text-lg font-medium text-white transition ease-in-out rounded-none rounded-full bg-green hover:bg-primary' >
          LOGIN
         </button>
          <div className="py-4 mt-4 text-center border rounded-lg">
            <Title>OR SIGNIN WITH</Title>
            <div className="flex items-center justify-center gap-5 mt-5">
              <button className="flex items-center gap-2 p-3 px-5 text-white bg-red-500 rounded-sm">
                <FaGoogle />
                <p className="text-sm">SIGNIN WHIT GOOGLE</p>
              </button>
              <button className="flex items-center gap-2 p-3 px-5 text-white bg-indigo-500 rounded-sm">
                <FaFacebook />
                <p className="text-sm">SIGNIN WHIT FACEBOOK</p>
              </button>
            </div>
          </div>
          <p className="mt-5 text-center">
            By clicking the signup button, you create a Cobiro account, and you agree to Cobiros <span className="underline text-green">Terms & Conditions</span> &
            <span className="underline text-green"> Privacy Policy </span> .
          </p>
        </form>
        <div className="absolute right-0 rounded-full bg-green w-96 h-96 opacity-20 blur-3xl bottom-96"></div>
      </section>
      <ToastContainer />
    </>
  );
};
